<script>
  export let text
  export let img
</script>

<div class='feature'>
  <figure>
    <img src={img} alt={img ? img.split('.')[0] : ""}>
    <figcaption>{text}</figcaption>
  </figure>
</div>

<style>
  .feature{
    width: 100%;
  }

  .feature:not(:first-child) {
    margin-left: 10px;
  }

  figure > img {
    width: 40%;
    height: auto;
    /* filter: drop-shadow(0px 4px 5px rgb(0 0 0 / 20%)); */
  }

  figcaption {
    padding-top: 1rem;
  }

  @media (min-width: 640px) {
		.feature {
			width: 50%;
		}
	}
</style>
